/* Silver Gems theme v2 — global behaviour.
   Everything works without JS; this layer adds AJAX add-to-cart, cart line
   updates via the Section Rendering API, and the mobile menu. */
(function () {
  'use strict';

  var SG = window.SG || { routes: {}, strings: {} };

  /* ---------- toast ---------- */

  var toastTimer;
  function toast(html) {
    var el = document.getElementById('sg-toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 4000);
  }

  /* ---------- header cart count ---------- */

  function setCartCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-sg-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* dropdown-details (header "Meer", collection filters) close on outside click */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.sg-filter-group[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sg-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    value += btn.getAttribute('data-sg-qty') === 'up' ? 1 : -1;
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- AJAX add to cart ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-sg-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return; /* request in flight */
    if (button) button.setAttribute('aria-disabled', 'true');

    var data = new FormData(form);
    var chainVar = form.querySelector('[data-sg-chain-variant]');
    var fetchOpts;
    if (chainVar && chainVar.value) {
      fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity') || '1', 10) },
          { id: parseInt(chainVar.value, 10), quantity: 1 }
        ] })
      };
    } else {
      fetchOpts = { method: 'POST', body: data, headers: { Accept: 'application/json' } };
    }
    fetch(SG.routes.cartAdd + '.js', fetchOpts)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        return fetch(SG.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        refreshCartSection();
        if (drawerEl) {
          refreshDrawer().then(drawerOpen);
        } else {
          toast(
            (SG.strings.added || 'Toegevoegd') +
              ' · <a href="' + SG.routes.cart + '">' + (SG.strings.viewCart || 'Bekijk winkelwagen') + '</a>'
          );
        }
      })
      .catch(function (err) {
        toast((err && err.description) || 'Er ging iets mis. Probeer het opnieuw.');
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-disabled');
      });
  });

  /* re-render the cart section in place (used after a quick-add on the cart page) */
  function refreshCartSection() {
    var wrapper = document.querySelector('[data-sg-cart-wrapper]');
    if (!wrapper) return;
    var sectionId = wrapper.getAttribute('data-sg-section-id');
    fetch(SG.routes.cart + '?sections=' + sectionId, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sg-cart-wrapper]');
        var current = document.querySelector('[data-sg-cart-wrapper]');
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  /* ---------- cart line updates (Section Rendering API) ---------- */

  /* One change in flight at a time: line numbers are 1-based positions in
     the *rendered* cart, so a second request against a stale render could
     hit the wrong line. While busy, further clicks are ignored. */
  var cartBusy = false;

  function rememberCartFocus(wrapper) {
    var el = document.activeElement;
    if (!el || !wrapper.contains(el)) return null;
    var qty = el.closest('.sg-qty');
    var input = el.hasAttribute('data-sg-line-qty')
      ? el
      : qty && qty.querySelector('[data-sg-line-qty]');
    var line = input
      ? input.getAttribute('data-sg-line')
      : el.getAttribute('data-sg-line-remove');
    if (line == null) return null;
    var ctrl = 'input';
    if (el.hasAttribute('data-sg-qty')) ctrl = el.getAttribute('data-sg-qty');
    else if (el.hasAttribute('data-sg-line-remove')) ctrl = 'remove';
    return { line: line, ctrl: ctrl };
  }

  function restoreCartFocus(mem) {
    if (!mem) return;
    var input =
      document.querySelector('[data-sg-line-qty][data-sg-line="' + mem.line + '"]') ||
      document.querySelector('[data-sg-line-qty]');
    if (!input) {
      var cta = document.querySelector('.sg-cart-summary .sg-btn');
      if (cta) cta.focus();
      return;
    }
    var target = input;
    if (mem.ctrl === 'up' || mem.ctrl === 'down') {
      target = input.parentElement.querySelector('[data-sg-qty="' + mem.ctrl + '"]') || input;
    } else if (mem.ctrl === 'remove') {
      var lineEl = input.closest('.sg-cart-line');
      var removeEl = lineEl && lineEl.querySelector('[data-sg-line-remove]');
      if (removeEl) target = removeEl;
    }
    target.focus();
  }

  function cartChange(payload, wrapper) {
    if (cartBusy) return;
    cartBusy = true;
    var sectionId = wrapper.getAttribute('data-sg-section-id');
    payload.sections = sectionId;
    var focusMem = rememberCartFocus(wrapper);
    wrapper.style.opacity = '0.55';
    fetch(SG.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok) {
          toast((res.json && res.json.description) || 'Er ging iets mis bij het bijwerken. Probeer het opnieuw.');
          wrapper.style.opacity = '';
          return;
        }
        var cart = res.json;
        if (cart.sections && cart.sections[sectionId]) {
          var doc = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
          var fresh = doc.querySelector('[data-sg-cart-wrapper]');
          var current = document.querySelector('[data-sg-cart-wrapper]');
          if (fresh && current) {
            current.replaceWith(fresh);
            restoreCartFocus(focusMem);
          }
        } else {
          wrapper.style.opacity = '';
        }
        setCartCount(cart.item_count);
      })
      .catch(function () {
        toast('Er ging iets mis bij het bijwerken. Probeer het opnieuw.');
        wrapper.style.opacity = '';
      })
      .finally(function () {
        cartBusy = false;
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sg-line-qty]');
    if (!input) return;
    var wrapper = input.closest('[data-sg-cart-wrapper]');
    if (!wrapper) return;
    cartChange(
      { line: parseInt(input.getAttribute('data-sg-line'), 10), quantity: parseInt(input.value, 10) || 0 },
      wrapper
    );
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-sg-line-remove]');
    if (!link) return;
    var wrapper = link.closest('[data-sg-cart-wrapper]');
    if (!wrapper) return;
    e.preventDefault();
    cartChange({ line: parseInt(link.getAttribute('data-sg-line-remove'), 10), quantity: 0 }, wrapper);
  });

  /* ---------- sticky mobile buy bar ---------- */

  (function () {
    var sticky = document.querySelector('[data-sg-sticky-atc]');
    var buyRow = document.querySelector('.sg-buy-row');
    if (!sticky || !buyRow || !('IntersectionObserver' in window)) return;
    var btn = sticky.querySelector('button');
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    });
    io.observe(buyRow);
  })();

  /* ---------- cart drawer ---------- */

  var drawerEl = document.getElementById('sg-cart-drawer');
  var drawerOverlay = document.querySelector('[data-sg-drawer-overlay]');
  var drawerLastFocus = null;
  var drawerBusy = false;

  function drawerOpen() {
    if (!drawerEl) return;
    drawerLastFocus = document.activeElement;
    drawerEl.hidden = false;
    if (drawerOverlay) drawerOverlay.hidden = false;
    requestAnimationFrame(function () {
      drawerEl.classList.add('is-open');
      if (drawerOverlay) drawerOverlay.classList.add('is-open');
    });
    document.body.classList.add('sg-drawer-lock');
    var close = drawerEl.querySelector('[data-sg-drawer-close]');
    if (close) close.focus();
  }

  function drawerClose() {
    if (!drawerEl || drawerEl.hidden) return;
    drawerEl.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    document.body.classList.remove('sg-drawer-lock');
    setTimeout(function () {
      drawerEl.hidden = true;
      if (drawerOverlay) drawerOverlay.hidden = true;
    }, 280);
    if (drawerLastFocus && drawerLastFocus.focus) drawerLastFocus.focus();
  }

  function refreshDrawer() {
    if (!drawerEl) return Promise.resolve();
    return fetch('/?section_id=sg-cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sg-drawer-content]');
        var current = drawerEl.querySelector('[data-sg-drawer-content]');
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  /* open from the header cart icon (not on the cart page itself) */
  document.addEventListener('click', function (e) {
    if (!drawerEl || document.body.classList.contains('template-cart')) return;
    var link = e.target.closest('a[data-sg-cart-toggle]');
    if (!link) return;
    e.preventDefault();
    drawerOpen();
    refreshDrawer();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sg-drawer-close]') || e.target.closest('[data-sg-drawer-overlay]')) {
      drawerClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!drawerEl || drawerEl.hidden) return;
    if (e.key === 'Escape') {
      drawerClose();
      return;
    }
    if (e.key === 'Tab') {
      var focusables = drawerEl.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  function drawerLineChange(line, quantity) {
    if (drawerBusy) return;
    drawerBusy = true;
    fetch(SG.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok) {
          toast((res.json && res.json.description) || 'Er ging iets mis bij het bijwerken. Probeer het opnieuw.');
          return refreshDrawer();
        }
        setCartCount(res.json.item_count);
        refreshCartSection();
        return refreshDrawer();
      })
      .catch(function () {
        toast('Er ging iets mis bij het bijwerken. Probeer het opnieuw.');
      })
      .finally(function () {
        drawerBusy = false;
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sg-drawer-qty]');
    if (!input) return;
    drawerLineChange(parseInt(input.getAttribute('data-sg-line'), 10), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sg-drawer-remove]');
    if (!btn) return;
    drawerLineChange(parseInt(btn.getAttribute('data-sg-drawer-remove'), 10), 0);
  });

  /* ---------- slideshow ---------- */

  function initSlideshow(root) {
    var slides = root.querySelectorAll('[data-sg-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-sg-slide-dot]');
    var pauseBtn = root.querySelector('[data-sg-slide-pause]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced;
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;
    var idx = 0;
    var timer = null;
    var paused = false;

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }
    function start() {
      if (autoplay && !paused && !timer) {
        timer = setInterval(function () { go(idx + 1); }, speed);
      }
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }
    function restart() { stop(); start(); }

    var prev = root.querySelector('[data-sg-slide-prev]');
    var next = root.querySelector('[data-sg-slide-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); restart(); });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Diavoorstelling hervatten' : 'Diavoorstelling pauzeren');
        if (paused) stop(); else start();
      });
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    var startX = null;
    root.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    root.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) {
        go(dx < 0 ? idx + 1 : idx - 1);
        restart();
      }
    });

    start();
  }
  /* kettingkeuze: advies, detail en lengte in afzonderlijke schermen */
  (function () {
    var trigger = document.querySelector('[data-sg-chainpop-toggle]');
    var modal = document.getElementById('sg-chainpop');
    if (!trigger || !modal) return;
    var overlay = document.querySelector('[data-sg-chainpop-overlay]');
    var hidden = document.querySelector('[data-sg-chain-variant]');
    var browse = modal.querySelector('[data-sg-chainpop-browse]');
    var detail = modal.querySelector('[data-sg-chainpop-detail]');
    var lengthOpts = modal.querySelector('[data-sg-chainpop-length-options]');
    var detailImage = modal.querySelector('[data-sg-chainpop-detail-image]');
    var pendantImage = modal.querySelector('[data-sg-chainpop-detail-pendant]');
    var detailTitle = modal.querySelector('[data-sg-chainpop-detail-title]');
    var detailPrice = modal.querySelector('[data-sg-chainpop-detail-price]');
    var detailLink = modal.querySelector('[data-sg-chainpop-detail-link]');
    var confirm = modal.querySelector('[data-sg-chainpop-confirm]');
    var heading = modal.querySelector('[data-sg-chainpop-heading]');
    var nameEl = document.querySelector('[data-sg-chainpop-name]');
    var priceEl = document.querySelector('[data-sg-chainpop-price]');
    var kickerEl = document.querySelector('[data-sg-chainpop-kicker]');
    var thumbWrap = document.querySelector('[data-sg-chainpop-thumbwrap]');
    var promptIcon = thumbWrap ? thumbWrap.innerHTML : '';
    var pending = null;
    var selectedVariant = null;
    var selectedChain = null;
    var lastFocus = null;

    function setHeading(text) {
      if (heading) heading.textContent = text;
      modal.setAttribute('aria-label', text);
    }
    function syncSelectedChain() {
      modal.querySelectorAll('[data-sg-chainpop-pick]').forEach(function (item) {
        var active = selectedChain && item.getAttribute('data-chain-key') === selectedChain.key;
        item.classList.toggle('is-active', !!active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    function showBrowse() {
      browse.hidden = false;
      detail.hidden = true;
      setHeading('Kies je ketting');
      syncSelectedChain();
    }
    function open() {
      lastFocus = document.activeElement;
      showBrowse();
      modal.hidden = false;
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        var closeButton = modal.querySelector('[data-sg-chainpop-close]');
        if (closeButton) closeButton.focus();
      });
      document.body.classList.add('sg-drawer-lock');
    }
    function close() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('sg-drawer-lock');
      setTimeout(function () {
        modal.hidden = true;
        if (overlay) overlay.hidden = true;
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }, 320);
    }
    function setTrigger(chain) {
      if (!chain) {
        if (kickerEl) kickerEl.textContent = 'Optioneel';
        if (nameEl) nameEl.textContent = 'Kies je ketting';
        if (priceEl) { priceEl.textContent = ''; priceEl.hidden = true; }
        if (thumbWrap) {
          thumbWrap.classList.add('sg-chainpop-thumb--prompt');
          thumbWrap.innerHTML = promptIcon;
        }
        return;
      }
      if (kickerEl) kickerEl.textContent = 'Gekozen ketting';
      if (nameEl) nameEl.textContent = chain.name + ' · ' + chain.variant.title;
      if (priceEl) { priceEl.textContent = '+ ' + chain.variant.price; priceEl.hidden = false; }
      if (thumbWrap) {
        thumbWrap.classList.remove('sg-chainpop-thumb--prompt');
        thumbWrap.innerHTML = '';
        if (chain.thumb) {
          var img = document.createElement('img');
          img.src = chain.thumb;
          img.alt = '';
          thumbWrap.appendChild(img);
        }
      }
    }
    function clearSelection() {
      selectedChain = null;
      selectedVariant = null;
      pending = null;
      hidden.value = '';
      setTrigger(null);
      close();
    }
    function selectLength(button, variant) {
      selectedVariant = variant;
      lengthOpts.querySelectorAll('[data-sg-chainpop-length]').forEach(function (option) {
        option.classList.toggle('is-active', option === button);
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });
      confirm.disabled = false;
      confirm.textContent = 'Ketting toevoegen · ' + variant.price;
    }
    function showDetail() {
      selectedVariant = null;
      setHeading('Kies je lengte');
      if (detailImage) {
        detailImage.src = pending.image || pending.thumb;
        detailImage.alt = pending.name;
      }
      if (pendantImage) {
        var galleryImage = document.querySelector('[data-sg-gallery-main] img');
        if (galleryImage && galleryImage.currentSrc) pendantImage.src = galleryImage.currentSrc;
      }
      if (detailTitle) detailTitle.textContent = pending.name;
      if (detailPrice) detailPrice.textContent = pending.price;
      if (detailLink) {
        detailLink.href = pending.url || '#';
        detailLink.hidden = !pending.url;
      }
      confirm.disabled = true;
      confirm.textContent = 'Kies eerst je lengte';
      lengthOpts.innerHTML = '';
      var activeLengthButton = null;
      pending.variants.forEach(function (variant) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sg-chainpop-detail__length';
        button.setAttribute('data-sg-chainpop-length', '');
        button.setAttribute('aria-pressed', 'false');
        var label = document.createElement('span');
        label.textContent = variant.title;
        var price = document.createElement('strong');
        price.textContent = variant.price;
        button.appendChild(label);
        button.appendChild(price);
        button.addEventListener('click', function () { selectLength(button, variant); });
        lengthOpts.appendChild(button);
        if (selectedChain && selectedChain.key === pending.key && String(selectedChain.variant.id) === String(variant.id)) activeLengthButton = button;
      });
      browse.hidden = true;
      detail.hidden = false;
      if (activeLengthButton) {
        var activeVariant = pending.variants.filter(function (variant) { return String(variant.id) === String(selectedChain.variant.id); })[0];
        selectLength(activeLengthButton, activeVariant);
      }
    }
    function resolve() {
      if (!selectedVariant || !pending) return;
      selectedChain = {
        key: pending.key,
        name: pending.name,
        thumb: pending.thumb,
        variant: selectedVariant
      };
      hidden.value = selectedVariant.id;
      setTrigger(selectedChain);
      close();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sg-chainpop-toggle]')) { open(); return; }
      if (e.target.closest('[data-sg-chainpop-close]') || e.target.closest('[data-sg-chainpop-overlay]')) { close(); return; }
      if (e.target.closest('[data-sg-chainpop-back]')) { showBrowse(); return; }
      if (e.target.closest('[data-sg-chainpop-confirm]') && selectedVariant) { resolve(); return; }
      if (e.target.closest('[data-sg-chainpop-none]')) { clearSelection(); return; }
      var pick = e.target.closest('[data-sg-chainpop-pick]');
      if (pick && modal.contains(pick)) {
        var variants;
        try { variants = JSON.parse(pick.getAttribute('data-variants') || '[]'); } catch (err) { variants = []; }
        if (!variants.length) { clearSelection(); return; }
        pending = {
          key: pick.getAttribute('data-chain-key') || '',
          name: pick.getAttribute('data-name') || '',
          thumb: pick.getAttribute('data-thumb') || '',
          image: pick.getAttribute('data-image') || pick.getAttribute('data-thumb') || '',
          price: pick.getAttribute('data-price') || '',
          url: pick.getAttribute('data-url') || '',
          variants: variants
        };
        showDetail();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  /* review-callout: rustig naar de beoordelingen, zonder harde anchor-sprong */
  (function () {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-sg-scroll-review]');
      if (!link) return;
      var reviews = document.getElementById('beoordelingen');
      if (!reviews) return;
      event.preventDefault();
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      reviews.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  /* info-popups: [data-sg-pop-open="<id>"] opent #<id> (kwaliteit, verhaal,
     verzending, garantie) met een gedeelde overlay */
  (function () {
    var overlay = document.querySelector('[data-sg-pop-overlay]');
    /*
      These dialogs are rendered inside the desktop product-info column, which
      is sticky. A sticky ancestor creates a stacking context, so product cards
      further down the page could otherwise paint above the fixed dialog.
      Move the shared overlay and these dialogs to the document root once, so
      every product-detail modal always lives in the top page layer.
    */
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    document.querySelectorAll('.sg-infopop').forEach(function (pop) {
      if (pop.parentElement !== document.body) document.body.appendChild(pop);
    });
    var current = null;
    var last = null;
    function open(id) {
      var pop = document.getElementById(id);
      if (!pop) return;
      last = document.activeElement;
      current = pop;
      /* steenpopup kleurt mee met de actieve steen */
      var act = pop.querySelector('[data-sg-story-panel]:not([hidden])');
      var body = pop.querySelector('.sg-pop__body');
      if (body) body.style.background = act && act.getAttribute('data-tint') ? act.getAttribute('data-tint') : '';
      pop.hidden = false;
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      document.body.classList.add('sg-drawer-lock');
      var c = pop.querySelector('[data-sg-pop-close]');
      if (c) c.focus();
    }
    function close() {
      if (!current) return;
      var pop = current;
      current = null;
      pop.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('sg-drawer-lock');
      setTimeout(function () {
        pop.hidden = true;
        if (overlay) overlay.hidden = true;
      }, 320);
      if (last && last.focus) last.focus();
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sg-pop-open]');
      if (t) { open(t.getAttribute('data-sg-pop-open')); return; }
      if (e.target.closest('[data-sg-pop-close]') || e.target.closest('[data-sg-pop-overlay]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) close();
    });
  })();

  /* favoriet-hart: lokaal bewaard tot er een echte verlanglijst is */
  (function () {
    var favBtn = document.querySelector('[data-sg-fav]');
    if (!favBtn) return;
    var key = 'sg-favs';
    var handle = favBtn.getAttribute('data-sg-fav');
    function favs() {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    function renderState() {
      var on = favs().indexOf(handle) !== -1;
      favBtn.classList.toggle('is-active', on);
      favBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    favBtn.addEventListener('click', function () {
      var list = favs();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      renderState();
    });
    renderState();
  })();

  document.querySelectorAll('[data-sg-slideshow]').forEach(initSlideshow);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sg-slideshow]');
    if (root) initSlideshow(root);
  });

  /* ---------- tekst-uitklappers (PDP korte beschrijving, collectie-SEO-tekst) ---------- */

  document.querySelectorAll('[data-sg-shortdesc]').forEach(function (wrap) {
    var text = wrap.querySelector('[data-sg-shortdesc-text]');
    var btn = wrap.querySelector('[data-sg-shortdesc-toggle]');
    if (!text || !btn) return;
    if (text.scrollHeight > text.clientHeight + 4) btn.hidden = false;
    btn.addEventListener('click', function () {
      var expanded = !text.classList.contains('is-clamped');
      if (expanded) {
        text.classList.add('is-clamped');
        btn.textContent = 'Lees meer';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        text.classList.remove('is-clamped');
        btn.textContent = 'Lees minder';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- collectie: filter- en sorteerlade ---------- */

  (function () {
    var activeBar = null;
    function controls() {
      return {
        filterBar: document.querySelector('[data-sg-filterbar]'),
        sortBar: document.querySelector('[data-sg-sortbar]'),
        overlay: document.querySelector('[data-sg-filterbar-overlay]')
      };
    }
    function setExpanded(target, expanded) {
      document.querySelectorAll(target).forEach(function (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
    function open(bar, toggle) {
      if (!bar) return;
      if (activeBar && activeBar !== bar) activeBar.classList.remove('is-open');
      bar.classList.add('is-open');
      activeBar = bar;
      setExpanded('[data-sg-filterbar-toggle], [data-sg-sortbar-toggle]', false);
      setExpanded(toggle, true);
      var overlay = controls().overlay;
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
      document.body.classList.add('sg-drawer-lock');
    }
    function close() {
      var current = controls();
      if (current.filterBar) current.filterBar.classList.remove('is-open');
      if (current.sortBar) current.sortBar.classList.remove('is-open');
      activeBar = null;
      setExpanded('[data-sg-filterbar-toggle], [data-sg-sortbar-toggle]', false);
      var overlay = current.overlay;
      if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { overlay.hidden = true; }, 280); }
      document.body.classList.remove('sg-drawer-lock');
    }
    document.addEventListener('click', function (e) {
      var current = controls();
      if (e.target.closest('[data-sg-filterbar-toggle]')) { open(current.filterBar, '[data-sg-filterbar-toggle]'); return; }
      if (e.target.closest('[data-sg-sortbar-toggle]')) { open(current.sortBar, '[data-sg-sortbar-toggle]'); return; }
      if (e.target.closest('[data-sg-filterbar-close]') || e.target.closest('[data-sg-sortbar-close]') || e.target.closest('[data-sg-filterbar-overlay]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    document.addEventListener('sg:collection-swap', close);
  })();

  /* ---------- maat-kiezer voor quick-add met varianten ---------- */

  var sizepickerEl = document.getElementById('sg-sizepicker');
  var sizepickerOverlay = document.querySelector('[data-sg-sizepicker-overlay]');

  function sizepickerClose() {
    if (!sizepickerEl || sizepickerEl.hidden) return;
    sizepickerEl.classList.remove('is-open');
    if (sizepickerOverlay) sizepickerOverlay.classList.remove('is-open');
    document.body.classList.remove('sg-drawer-lock');
    setTimeout(function () {
      sizepickerEl.hidden = true;
      if (sizepickerOverlay) sizepickerOverlay.hidden = true;
    }, 280);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sg-sizepicker]');
    if (trigger && sizepickerEl) {
      var variants;
      try { variants = JSON.parse(trigger.getAttribute('data-sg-sizepicker')); } catch (err) { return; }
      sizepickerEl.querySelector('[data-sg-sizepicker-product]').textContent = trigger.getAttribute('data-sg-sizepicker-title') || '';
      sizepickerEl.querySelector('[data-sg-sizepicker-option]').textContent = trigger.getAttribute('data-sg-sizepicker-option') || 'Maat';
      var wrap = sizepickerEl.querySelector('[data-sg-sizepicker-options]');
      wrap.innerHTML = '';
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = v.title;
        b.disabled = !v.available;
        b.addEventListener('click', function () {
          b.disabled = true;
          fetch(SG.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          })
            .then(function (r) {
              if (!r.ok) return r.json().then(function (j) { throw j; });
              return fetch(SG.routes.cart + '.js', { headers: { Accept: 'application/json' } });
            })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              setCartCount(cart.item_count);
              refreshCartSection();
              sizepickerClose();
              if (drawerEl) {
                refreshDrawer().then(drawerOpen);
              } else {
                toast((SG.strings.added || 'Toegevoegd') + ' · <a href="' + SG.routes.cart + '">' + (SG.strings.viewCart || 'Bekijk winkelwagen') + '</a>');
              }
            })
            .catch(function (err) {
              b.disabled = false;
              toast((err && err.description) || 'Er ging iets mis. Probeer het opnieuw.');
            });
        });
        wrap.appendChild(b);
      });
      sizepickerEl.hidden = false;
      if (sizepickerOverlay) sizepickerOverlay.hidden = false;
      requestAnimationFrame(function () {
        sizepickerEl.classList.add('is-open');
        if (sizepickerOverlay) sizepickerOverlay.classList.add('is-open');
      });
      document.body.classList.add('sg-drawer-lock');
      var close = sizepickerEl.querySelector('[data-sg-sizepicker-close]');
      if (close) close.focus();
      return;
    }
    if (e.target.closest('[data-sg-sizepicker-close]') || e.target.closest('[data-sg-sizepicker-overlay]')) {
      sizepickerClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') sizepickerClose();
  });

  /* ---------- PDP: maatgids drawer ---------- */

  var sizeguideEl = document.getElementById('sg-sizeguide');
  var sizeguideOverlay = document.querySelector('[data-sg-sizeguide-overlay]');
  var sizeguideLastFocus = null;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sg-sizeguide-toggle]')) {
      if (!sizeguideEl) return;
      sizeguideLastFocus = document.activeElement;
      sizeguideEl.hidden = false;
      if (sizeguideOverlay) sizeguideOverlay.hidden = false;
      requestAnimationFrame(function () {
        sizeguideEl.classList.add('is-open');
        if (sizeguideOverlay) sizeguideOverlay.classList.add('is-open');
      });
      document.body.classList.add('sg-drawer-lock');
      var close = sizeguideEl.querySelector('[data-sg-sizeguide-close]');
      if (close) close.focus();
      return;
    }
    if (e.target.closest('[data-sg-sizeguide-close]') || e.target.closest('[data-sg-sizeguide-overlay]')) {
      sizeguideClose();
    }
  });

  function sizeguideClose() {
    if (!sizeguideEl || sizeguideEl.hidden) return;
    sizeguideEl.classList.remove('is-open');
    if (sizeguideOverlay) sizeguideOverlay.classList.remove('is-open');
    document.body.classList.remove('sg-drawer-lock');
    setTimeout(function () {
      sizeguideEl.hidden = true;
      if (sizeguideOverlay) sizeguideOverlay.hidden = true;
    }, 280);
    if (sizeguideLastFocus && sizeguideLastFocus.focus) sizeguideLastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') sizeguideClose();
  });

  /* ---------- variantgalerij: wissel media per gekozen variant ---------- */

  (function () {
    var mapEl = document.querySelector('[data-sg-gallery-map]');
    var gallery = document.querySelector('[data-sg-gallery]');
    if (!mapEl || !gallery) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    function slugify(s) {
      return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    function listForVariant(variantId) {
      var v = map.variants[variantId];
      if (!v) return null;
      var ids = (v.media || []).slice();
      var shared = map.shared || [];
      if (ids.length) {
        shared.forEach(function (id) { if (ids.indexOf(id) === -1) ids.push(id); });
        return ids;
      }
      /* terugval 1: alt-conventie steen:<slug> plus steen:all */
      var slug = slugify(v.option);
      var byAlt = [];
      var sharedAlt = [];
      (map.order || []).forEach(function (id) {
        var alt = ((map.media[id] || {}).alt || '').toLowerCase();
        if (slug && alt.indexOf('steen:' + slug) !== -1) byAlt.push(id);
        else if (alt.indexOf('steen:all') !== -1) sharedAlt.push(id);
      });
      if (byAlt.length) return byAlt.concat(sharedAlt);
      /* terugval 2: volledige galerij ongewijzigd */
      return null;
    }

    function setMain(main, m) {
      /* eerst voorladen, dan pas wisselen: het oude beeld blijft staan tot
         het nieuwe er is, zodat een wissel nooit een leeg vlak toont */
      var pre = new Image();
      pre.onload = function () {
        main.src = m.src;
        main.srcset = m.srcset;
        main.alt = m.alt || '';
        main.style.opacity = '';
      };
      main.style.opacity = '0.7';
      pre.srcset = m.srcset;
      pre.src = m.src;
      if (pre.complete) pre.onload();
    }

    function rebuild(ids) {
      var main = gallery.querySelector('[data-sg-gallery-main] img');
      var thumbsWrap = gallery.querySelector('.sg-gallery__thumbs');
      var full = !ids || !ids.length;
      var list = full ? (map.order || []) : ids;
      if (!list.length || !main) return;
      var first = map.media[list[0]];
      if (!first) return;
      setMain(main, first);
      if (thumbsWrap) {
        if (list.length > 1) {
          thumbsWrap.innerHTML = '';
          list.slice(0, 12).forEach(function (id, i) {
            var m = map.media[id];
            if (!m) return;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sg-gallery__thumb';
            b.setAttribute('data-sg-thumb', m.src);
            b.setAttribute('data-sg-thumb-srcset', m.srcset);
            b.setAttribute('data-sg-thumb-alt', m.alt || '');
            b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            b.setAttribute('aria-label', 'Afbeelding ' + (i + 1) + ' van ' + list.length);
            var img = document.createElement('img');
            img.src = m.thumb;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 72;
            img.height = 72;
            b.appendChild(img);
            thumbsWrap.appendChild(b);
          });
          thumbsWrap.hidden = false;
        } else {
          thumbsWrap.innerHTML = '';
          thumbsWrap.hidden = true;
        }
      }
      /* desktop-raster volgt dezelfde selectie */
      var gridWrap = gallery.querySelector('[data-sg-gallery-grid]');
      if (gridWrap) {
        gridWrap.innerHTML = '';
        list.slice(0, 16).forEach(function (id) {
          var m = map.media[id];
          if (!m) return;
          var img = document.createElement('img');
          img.src = m.src;
          img.srcset = m.srcset;
          img.sizes = '(min-width: 900px) 34vw, 92vw';
          img.alt = m.alt || '';
          img.loading = 'lazy';
          gridWrap.appendChild(img);
        });
      }
      preloadStrip();
    }

    /* alle zichtbare thumbs op volle grootte voorladen zodat een klik
       direct wisselt */
    function preloadStrip() {
      document.querySelectorAll('.sg-gallery__thumb').forEach(function (b) {
        var img = new Image();
        var ss = b.getAttribute('data-sg-thumb-srcset');
        if (ss) img.srcset = ss;
        img.src = b.getAttribute('data-sg-thumb') || '';
      });
    }
    var idleP = window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); };
    idleP(preloadStrip);

    /* steengebonden teksten volgen de gekozen variant */
    function applyTexts(variantId) {
      var v = map.variants[String(variantId)];
      if (!v || !map.texts) return;
      var t = map.texts[v.option];
      if (!t) return;
      var short = document.querySelector('[data-sg-shortdesc-text]');
      var shortWrap = document.querySelector('[data-sg-shortdesc]');
      if (short && shortWrap && !shortWrap.hasAttribute('data-sg-shortdesc-fixed')) {
        short.textContent = t.short;
      }
      var spec = document.querySelector('[data-sg-spec-stone]');
      if (spec) spec.textContent = t.name;
      /* de wisselplek in de H1: "edelsteen" wordt de gekozen steen */
      var titleStone = document.querySelector('[data-sg-title-stone]');
      if (titleStone) titleStone.textContent = t.name;
      var storyHeads = document.querySelectorAll('[data-sg-story-heading]');
      var storyBody = document.querySelector('[data-sg-story-body]');
      if (storyBody) {
        var storyRow = document.querySelector('[data-sg-story-row]');
        var storyBase = t.name.replace(/\s+(I|II|III|IV|V)$/, '');
        var storyPanel = null;
        document.querySelectorAll('[data-sg-story-panel]').forEach(function (p) {
          var on = p.getAttribute('data-stone') === storyBase;
          p.hidden = !on;
          if (on) storyPanel = p;
        });
        storyHeads.forEach(function (h) { h.textContent = 'Het verhaal van ' + storyBase; });
        if (storyPanel) {
          storyBody.hidden = true;
          if (storyRow) storyRow.hidden = false;
        } else if (t.story) {
          storyBody.hidden = false;
          storyBody.innerHTML = '<p></p>';
          storyBody.firstChild.textContent = t.story;
          if (storyRow) storyRow.hidden = false;
        } else if (storyRow) {
          storyRow.hidden = true;
        }
      }
      var careBody = document.querySelector('[data-sg-care-body]');
      if (careBody && t.care) careBody.innerHTML = t.care;
    }

    function apply(variantId) {
      rebuild(listForVariant(String(variantId)));
      applyTexts(variantId);
      /* artikelnummer volgt de gekozen variant */
      var skuEl = document.querySelector('[data-sg-product-sku]');
      var skuVar = map.variants[String(variantId)];
      if (skuEl && skuVar) {
        var skuVal = skuEl.querySelector('[data-sg-product-sku-value]');
        if (skuVal) skuVal.textContent = skuVar.sku || '';
        skuEl.hidden = !skuVar.sku;
      }
      var priceInput = document.querySelector('.sg-variant-chips input[name="id"][value="' + variantId + '"], .sg-varimg input[name="id"][value="' + variantId + '"]');
      var priceEl = document.querySelector('[data-sg-product-price]');
      if (priceInput && priceEl) {
        var amount = priceEl.querySelector('[data-sg-product-price-amount]');
        var compare = priceEl.querySelector('[data-sg-product-price-compare]');
        var discount = priceEl.querySelector('[data-sg-product-price-discount]');
        var comparePrice = priceInput.getAttribute('data-compare') || '';
        var discountText = priceInput.getAttribute('data-discount') || '';
        if (amount) amount.textContent = priceInput.getAttribute('data-price') || '';
        if (comparePrice) {
          if (!compare) {
            compare = document.createElement('s');
            compare.className = 'sg-product__price-compare';
            compare.setAttribute('data-sg-product-price-compare', '');
            priceEl.insertBefore(compare, amount);
          }
          compare.textContent = comparePrice;
          if (!discount) {
            discount = document.createElement('span');
            discount.className = 'sg-product__price-discount';
            discount.setAttribute('data-sg-product-price-discount', '');
            priceEl.appendChild(discount);
          }
          discount.textContent = discountText;
          priceEl.classList.add('is-sale');
        } else {
          if (compare) compare.remove();
          if (discount) discount.remove();
          priceEl.classList.remove('is-sale');
        }
        var stickyPrice = document.querySelector('.sg-sticky-atc__price');
        if (stickyPrice) stickyPrice.textContent = priceInput.getAttribute('data-price') || '';
      }
    }

    document.addEventListener('change', function (e) {
      var input = e.target.closest('.sg-variant-chips input[name="id"], .sg-varimg input[name="id"]');
      if (!input) return;
      apply(input.value);
      var nameEl = document.querySelector('[data-sg-varname]');
      if (nameEl && input.getAttribute('data-name')) nameEl.textContent = input.getAttribute('data-name');
    });

    var checked = document.querySelector('.sg-variant-chips input[name="id"]:checked, .sg-varimg input[name="id"]:checked');
    if (checked) apply(checked.value);

    /* popup-variantkiezer */
    var varpopEl = document.getElementById('sg-varpop');
    var varpopOverlay = document.querySelector('[data-sg-varpop-overlay]');
    function varpopClose() {
      if (!varpopEl || varpopEl.hidden) return;
      varpopEl.classList.remove('is-open');
      if (varpopOverlay) varpopOverlay.classList.remove('is-open');
      /* timeout hieronder moet >= de 0.3s slide-transition blijven */
      document.body.classList.remove('sg-drawer-lock');
      setTimeout(function () {
        varpopEl.hidden = true;
        if (varpopOverlay) varpopOverlay.hidden = true;
      }, 320);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sg-varpop-toggle]') && varpopEl) {
        varpopEl.hidden = false;
        if (varpopOverlay) varpopOverlay.hidden = false;
        requestAnimationFrame(function () {
          varpopEl.classList.add('is-open');
          if (varpopOverlay) varpopOverlay.classList.add('is-open');
        });
        document.body.classList.add('sg-drawer-lock');
        return;
      }
      if (e.target.closest('[data-sg-varpop-close]') || e.target.closest('[data-sg-varpop-overlay]')) {
        varpopClose();
        return;
      }
      var pick = e.target.closest('[data-sg-varpop-pick]');
      if (pick) {
        var vid = pick.getAttribute('data-sg-varpop-pick');
        var radio = document.querySelector('.sg-variant-chips input[value="' + vid + '"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          var trigName = document.querySelector('[data-sg-varpop-name]');
          var trigThumb = document.querySelector('[data-sg-varpop-thumb]');
          if (trigName) trigName.textContent = radio.getAttribute('data-name') || '';
          if (trigThumb && radio.getAttribute('data-thumb')) trigThumb.src = radio.getAttribute('data-thumb');
          varpopEl.querySelectorAll('.sg-varpop-row, .sg-varpop-tile').forEach(function (r) {
            r.classList.toggle('is-active', r === pick);
          });
        }
        varpopClose();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') varpopClose();
    });

    /* cache voorverwarmen: het eerste beeld van elke variant op idle laden,
       zodat wisselen direct voelt (overslaan bij spaarstand of trage
       verbinding) */
    var conn = navigator.connection || {};
    if (!conn.saveData && String(conn.effectiveType || '').indexOf('2g') === -1) {
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1800); };
      idle(function () {
        var seen = {};
        Object.keys(map.variants).forEach(function (vid) {
          var list = listForVariant(vid);
          var firstId = list && list.length ? list[0] : null;
          if (!firstId || seen[firstId]) return;
          seen[firstId] = true;
          var m = map.media[firstId];
          if (!m) return;
          var img = new Image();
          img.srcset = m.srcset;
          img.src = m.src;
        });
      });
    }
  })();

  /* ---------- lage voorraad boven toevoegen ---------- */

  (function () {
    document.querySelectorAll('[data-sg-stock-urgency]').forEach(function (block) {
      var dataEl = block.querySelector('[data-sg-stock-urgency-data]');
      var form = block.closest('form[data-sg-product-form]');
      if (!dataEl || !form) return;

      var stock;
      try {
        stock = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var threshold = Number(block.getAttribute('data-stock-urgency-threshold')) || 8;
      var count = block.querySelector('[data-sg-stock-urgency-count]');

      function applyStock(variantId) {
        var item = stock[String(variantId)];
        var quantity = item ? Number(item.quantity) : 0;
        var show = item && item.tracked && item.available && quantity > 0 && quantity <= threshold;

        block.hidden = !show;
        if (!show) return;

        if (count) count.textContent = quantity;
        block.setAttribute('aria-label', 'Nog ' + quantity + ' op voorraad');
      }

      function selectedVariantId() {
        var selected = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
        return selected ? selected.value : null;
      }

      var initialId = selectedVariantId();
      if (initialId) applyStock(initialId);

      form.addEventListener('change', function (event) {
        var input = event.target.closest('input[name="id"]');
        if (input) applyStock(input.value);
      });
    });
  })();

  /* ---------- product gallery thumbs ---------- */

  function prepareGalleryTransition(main, direction) {
    if (!direction || !window.matchMedia('(max-width: 899px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return null;
    }

    var wrap = main.parentNode;
    wrap.querySelectorAll('.sg-gallery__image--outgoing').forEach(function (image) { image.remove(); });
    main.classList.remove('sg-gallery__image--incoming', 'sg-gallery__image--incoming-next', 'sg-gallery__image--incoming-previous');
    void main.offsetWidth;
    var transitionId = (main._sgGalleryTransition || 0) + 1;
    main._sgGalleryTransition = transitionId;

    var outgoing = main.cloneNode(true);
    outgoing.className = 'sg-gallery__image--outgoing sg-gallery__image--outgoing-' + direction;
    outgoing.setAttribute('aria-hidden', 'true');
    wrap.appendChild(outgoing);

    return function () {
      main.classList.add('sg-gallery__image--incoming', 'sg-gallery__image--incoming-' + direction);
      function finishTransition() {
        outgoing.remove();
        if (main._sgGalleryTransition !== transitionId) return;
        main.classList.remove('sg-gallery__image--incoming', 'sg-gallery__image--incoming-next', 'sg-gallery__image--incoming-previous');
      }
      main.addEventListener('animationend', finishTransition, { once: true });
      window.setTimeout(finishTransition, 380);
    };
  }

  function selectGalleryThumb(gallery, thumb, direction) {
    var main = gallery.querySelector('[data-sg-gallery-main] img');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-sg-thumb]'));
    var currentThumb = gallery.querySelector('[data-sg-thumb][aria-current="true"]');
    if (currentThumb === thumb) return;
    if (!direction && currentThumb && currentThumb !== thumb) {
      direction = thumbs.indexOf(thumb) > thumbs.indexOf(currentThumb) ? 'next' : 'previous';
    }
    var requestId = (gallery._sgGalleryImageRequest || 0) + 1;
    gallery._sgGalleryImageRequest = requestId;
    var src = thumb.getAttribute('data-sg-thumb');
    var srcset = thumb.getAttribute('data-sg-thumb-srcset') || '';
    var alt = thumb.getAttribute('data-sg-thumb-alt');
    var pre = new Image();
    var imageLoaded = false;
    function applyGalleryImage() {
      if (imageLoaded) return;
      imageLoaded = true;
      if (gallery._sgGalleryImageRequest !== requestId) return;
      var startTransition = prepareGalleryTransition(main, direction);
      main.src = src;
      main.srcset = srcset;
      if (alt !== null) main.alt = alt;
      if (startTransition) startTransition();
    }
    pre.onload = applyGalleryImage;
    if (srcset) pre.srcset = srcset;
    pre.src = src;
    if (pre.complete && pre.naturalWidth) applyGalleryImage();
    gallery.querySelectorAll('[data-sg-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
    if (window.matchMedia('(max-width: 899px)').matches && thumb.scrollIntoView) {
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-sg-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-sg-gallery]');
    if (!gallery) return;
    selectGalleryThumb(gallery, thumb);
  });

  document.querySelectorAll('[data-sg-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-sg-gallery-main]');
    if (!main) return;

    var pointerStart = null;
    var ignoreClick = false;

    main.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      if (main.setPointerCapture) main.setPointerCapture(event.pointerId);
    });

    main.addEventListener('pointerup', function (event) {
      if (!pointerStart || pointerStart.id !== event.pointerId) return;

      var dx = event.clientX - pointerStart.x;
      var dy = event.clientY - pointerStart.y;
      pointerStart = null;

      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;

      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-sg-thumb]'));
      if (thumbs.length < 2) return;

      var currentIndex = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('aria-current') === 'true';
      });
      var nextIndex = currentIndex + (dx < 0 ? 1 : -1);
      if (nextIndex < 0 || nextIndex >= thumbs.length) return;

      ignoreClick = true;
      selectGalleryThumb(gallery, thumbs[nextIndex], dx < 0 ? 'next' : 'previous');
      window.setTimeout(function () { ignoreClick = false; }, 500);
    });

    main.addEventListener('pointercancel', function () {
      pointerStart = null;
    });

    main.addEventListener('click', function (event) {
      if (!ignoreClick) return;
      event.preventDefault();
      event.stopPropagation();
      ignoreClick = false;
    });
  });
})();

/* ---------- homepage Instagram carousel ---------- */

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-sg-instagram-scroll]');
  if (!button) return;
  var carousel = button.closest('[data-sg-instagram-carousel]');
  var rail = carousel && carousel.querySelector('[data-sg-instagram-rail]');
  if (!rail) return;
  var tile = rail.querySelector('.sg-homeinstagram__tile');
  var gap = parseFloat(window.getComputedStyle(rail).gap) || 0;
  var distance = (tile ? tile.getBoundingClientRect().width : rail.clientWidth * 0.8) + gap;
  rail.scrollBy({
    left: button.getAttribute('data-sg-instagram-scroll') === 'previous' ? -distance : distance,
    behavior: 'smooth'
  });
});

/* ---------- reviewfoto: klein in de kaart, groot op aanvraag ---------- */

(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sg-review-image]');
    var dialog = document.querySelector('[data-sg-review-lightbox]');
    if (trigger && dialog) {
      var image = dialog.querySelector('img');
      if (!image) return;
      image.src = trigger.getAttribute('data-sg-review-image') || '';
      image.alt = trigger.getAttribute('data-sg-review-image-alt') || '';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    var close = event.target.closest('[data-sg-review-lightbox-close]');
    if (close && dialog) dialog.close();
    if (dialog && event.target === dialog) dialog.close();
  });
})();

/* ---------- beoordelingen: groeiende kaarten en stapsgewijs meer tonen ---------- */

(function () {
  function cardsFor(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-sg-review-card]'));
  }

  function layoutRail(rail) {
    if (!rail) return;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-sg-review-card]:not([hidden])'));
    var desktop = window.matchMedia('(min-width: 900px)').matches;

    rail.classList.toggle('sg-reviews__rail--masonry', desktop);
    cards.forEach(function (card) { card.style.gridRowEnd = ''; });
    if (!desktop || !cards.length) return;

    var styles = window.getComputedStyle(rail);
    var rowHeight = parseFloat(styles.gridAutoRows) || 8;
    var gap = parseFloat(styles.rowGap) || 14;
    cards.forEach(function (card) {
      var span = Math.ceil((card.getBoundingClientRect().height + gap) / (rowHeight + gap));
      card.style.gridRowEnd = 'span ' + Math.max(span, 1);
    });
  }

  function updateSection(section) {
    var cards = cardsFor(section);
    var rail = section.querySelector('[data-sg-reviews-rail]');
    var toggle = section.querySelector('[data-sg-reviews-toggle]');
    if (!rail || !toggle) return;

    var limit = parseInt(section.getAttribute('data-sg-review-limit'), 10) || 4;
    var visible = parseInt(section.getAttribute('data-sg-review-visible'), 10) || limit;
    visible = Math.min(Math.max(visible, limit), cards.length);
    section.setAttribute('data-sg-review-visible', visible);

    cards.forEach(function (card, index) { card.hidden = index >= visible; });
    toggle.hidden = cards.length <= limit;
    toggle.textContent = visible < cards.length ? 'Bekijk meer beoordelingen' : 'Toon minder beoordelingen';
    layoutRail(rail);
  }

  function updateAll() {
    document.querySelectorAll('[data-sg-reviews]').forEach(updateSection);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sg-reviews-toggle]');
    if (!toggle) return;
    var section = toggle.closest('[data-sg-reviews]');
    if (!section) return;

    var cards = cardsFor(section);
    var limit = parseInt(section.getAttribute('data-sg-review-limit'), 10) || 4;
    var step = parseInt(section.getAttribute('data-sg-review-step'), 10) || limit;
    var visible = parseInt(section.getAttribute('data-sg-review-visible'), 10) || limit;
    section.setAttribute('data-sg-review-visible', visible < cards.length ? Math.min(visible + step, cards.length) : limit);
    updateSection(section);
  });

  var reviewLayoutTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(reviewLayoutTimer);
    reviewLayoutTimer = window.setTimeout(updateAll, 120);
  });

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else updateAll();
})();

/* ---------- galerij-lightbox: klik voor groot, nogmaals voor 2x zoom ---------- */

(function () {
  var gallery = document.querySelector('[data-sg-gallery]');
  if (!gallery) return;
  var lb = null, stageImg = null, thumbsEl = null, items = [], idx = 0;

  function imageUrl(src, width) {
    if (/width=\d+/.test(src)) return src.replace(/width=\d+/, 'width=' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function currentList() {
    var els = gallery.querySelectorAll('[data-sg-gallery-grid] img');
    if (!els.length) els = gallery.querySelectorAll('[data-sg-gallery-main] img');
    return Array.prototype.map.call(els, function (el) {
      var src = el.currentSrc || el.src;
      return { big: imageUrl(src, 1600), thumb: imageUrl(src, 160), alt: el.alt || '' };
    });
  }

  var svgClose = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="m5 5 14 14M19 5 5 19"/></svg>';
  var svgUp = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m5 14 7-7 7 7"/></svg>';
  var svgDown = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m5 10 7 7 7-7"/></svg>';

  function build() {
    lb = document.createElement('div');
    lb.className = 'sg-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Fotogalerij');
    lb.innerHTML =
      '<button type="button" class="sg-lightbox__close" aria-label="Sluiten"><span>Sluiten</span>' + svgClose + '</button>' +
      '<div class="sg-lightbox__rail">' +
        '<button type="button" class="sg-lightbox__rail-btn sg-lightbox__prev" aria-label="Vorige foto">' + svgUp + '</button>' +
        '<div class="sg-lightbox__thumbs" aria-label="Kies een foto"></div>' +
        '<button type="button" class="sg-lightbox__rail-btn sg-lightbox__next" aria-label="Volgende foto">' + svgDown + '</button>' +
      '</div>' +
      '<div class="sg-lightbox__stage"><img alt=""></div>';
    document.body.appendChild(lb);
    stageImg = lb.querySelector('.sg-lightbox__stage img');
    thumbsEl = lb.querySelector('.sg-lightbox__thumbs');
    lb.querySelector('.sg-lightbox__close').addEventListener('click', close);
    lb.querySelector('.sg-lightbox__prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.sg-lightbox__next').addEventListener('click', function () { show(idx + 1); });
    stageImg.addEventListener('click', function (e) {
      var r = stageImg.getBoundingClientRect();
      stageImg.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      stageImg.classList.toggle('is-zoomed');
    });
    lb.querySelector('.sg-lightbox__stage').addEventListener('click', function (e) {
      if (e.target === e.currentTarget) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  function renderThumbs() {
    thumbsEl.innerHTML = '';
    thumbsEl.hidden = items.length < 2;
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sg-lightbox__thumb';
      b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' van ' + items.length);
      b.setAttribute('aria-current', i === idx ? 'true' : 'false');
      var img = document.createElement('img');
      img.src = item.thumb;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 80;
      img.height = 80;
      b.appendChild(img);
      b.addEventListener('click', function () { show(i); });
      thumbsEl.appendChild(b);
    });
  }

  function show(i) {
    idx = (i + items.length) % items.length;
    stageImg.classList.remove('is-zoomed');
    stageImg.src = items[idx].big;
    stageImg.alt = items[idx].alt;
    thumbsEl.querySelectorAll('.sg-lightbox__thumb').forEach(function (thumb, thumbIndex) {
      thumb.setAttribute('aria-current', thumbIndex === idx ? 'true' : 'false');
    });
    var activeThumb = thumbsEl.querySelector('.sg-lightbox__thumb[aria-current="true"]');
    if (activeThumb && activeThumb.scrollIntoView) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    var nxt = new Image();
    nxt.src = items[(idx + 1) % items.length].big;
  }

  function open(i) {
    items = currentList();
    if (!items.length) return;
    if (!lb) build();
    idx = i < 0 ? 0 : i;
    renderThumbs();
    document.documentElement.classList.add('sg-lightbox-open');
    lb.classList.add('is-open');
    show(idx);
  }

  function close() {
    stageImg.classList.remove('is-zoomed');
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('sg-lightbox-open');
  }

  gallery.addEventListener('click', function (e) {
    var t = e.target;
    if (t.tagName !== 'IMG') return;
    if (t.closest('[data-sg-gallery-grid]')) {
      var imgs = Array.prototype.slice.call(gallery.querySelectorAll('[data-sg-gallery-grid] img'));
      open(imgs.indexOf(t));
    } else if (t.closest('[data-sg-gallery-main]')) {
      open(0);
    }
  });
})();
